import { render, staticRenderFns } from "./controlHeader.vue?vue&type=template&id=1a25320a&scoped=true"
import script from "./controlHeader.vue?vue&type=script&lang=js"
export * from "./controlHeader.vue?vue&type=script&lang=js"
import style0 from "./controlHeader.vue?vue&type=style&index=0&id=1a25320a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a25320a",
  null
  
)

export default component.exports